import styled from '@emotion/styled';

export const ToolbarMobileLocationItemHolder = styled.div`
  display: none;
  @media (max-width: 30rem) {
    display: block;
  }
`;
